import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { ButtonController } from './ButtonController';

export interface IToggleButtonControllerOptions {
    onOff: boolean;
    onClick: () => void;
}

export class ToggleButtonController extends AnimationBaseController {
    $model: any;

    public onOff: boolean = false;

    public constructor(@Inject private _options: IToggleButtonControllerOptions) {
        super('ToggleButtonController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{};
    }

    public toggle(onOff: boolean) {
        this.onOff = onOff;
        this.gotoAndStop(this.onOff ? 'on' : 'off');

        this.removeChildControllerByName(!onOff ? 'button_on' : 'button_off');
        this.addChildController({
            instanceName: onOff ? 'button_on' : 'button_off',
            controller: ButtonController,
            options: {
                onClick: () => {
                    this.toggle(!this.onOff);

                    if (this._options.onClick) {
                        this._options.onClick();
                    }
                },
            },
        }, onOff ? 'button_on' : 'button_off');
    }

    protected onInitialize(): void {
        this.toggle(this._options.onOff);
    }
}
